import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {
  passImage: any;

  constructor() { 
    
  }

  changeImage(data: any){
   this.passImage = data;
  }

  bingingImage(){
    return this.passImage;
  }
}